<template>
  <div class="teate-list edit-item" v-if="editingData && options">
    <div class="head"><b>手当</b></div>
    <div class="data flex flex-align-center">
      <template v-if="teates && teates.length < 1">
        <p>無し</p>
        <div class="row-button" v-if="!disabled">
          <i class="fa-solid fa-circle-plus" @click="addTeate()"></i>
        </div>
      </template>

      <template v-else>
        <div class="flex flex-align-center teate" v-for=" (item, index) in teates" :key="index">
          <div class="item meimoku">
            <select-box :options="options.teate" v-model="item.mst_teate_id"
              :error="getError(editingData.teates![index], 'mst_teate_id')" :disabled="disabled"></select-box>
          </div>

          <div class="item kingaku flex flex-no-wrap flex-align-center">
            <input-text :type="'number'" inputmode="numeric" v-model="item.kingaku"
              :error="getError(editingData.teates![index], 'kingaku')" :disabled="disabled"></input-text>
            <p class="scale">円</p>
          </div>

          <div class="item row-button">
            <i class="fa-solid fa-delete-left" @click="removeTeate(index)" v-if="!disabled"></i>
            <template v-if="teates && (index + 1) === teates.length && !disabled">
              <i class="fa-solid fa-circle-plus" @click="addTeate()"></i>
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { KoyouKeiyakuOption, KoyouKeiyakuTeate } from '@/types/KoyouKeiyaku';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { useForm } from '@/composable/form/form';
import { useTableRow } from '@/composable/common/tablerow';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    options: {
      type: Object as () => KoyouKeiyakuOption | null,
      require: true,
      default: null,
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup(props) {

    const { getError } = useForm();
    const { addRowNoRef, removeTableRow } = useTableRow();

    // 行追加
    const addTeate = () => {
      if (!props.editingData || props.disabled) {
        return
      }
      if (props.editingData.teates === null) {
        props.editingData.teates = []
      }
      addRowNoRef(props.editingData.teates, (new KoyouKeiyakuTeate()));
    }

    // 行追加
    const removeTeate = (index: number) => {
      if (props.disabled || !props.editingData) {
        return
      }
      console.log(teates);
      removeTableRow(props.editingData.teates, index);
    }

    const teates = computed(() => {
      if (!props.editingData?.teates) {
        return null
      }
      return props.editingData.teates
    })

    return {
      getError,
      addTeate,
      removeTeate,
      teates
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

.teate {
  width: 100%;

  .item {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .meimoku {
    width: 200px;
  }

  .kingaku {
    width: 130px;
  }
}
</style>
